/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { PaginationConfig } from './pagination.config';

export const defaultPaginationConfig: PaginationConfig = {
  pagination: {
    addStart: true,
    addEnd: true,
  },
};
